const getters = {
  getShowFlg: state => uri => {
    // TODO: APIが対応したらこの暫定処理を削除する
    if (uri === '/admin/accounts/invitations') return true

    const urlAuth = state.uriAuths.find(urlAuth => urlAuth.uri === uri)
    if (urlAuth === undefined) return false
    return urlAuth.access
  },
}

export default getters
